import type { stacks, users } from "@dropbox/api-v2-client";
import i18n from "@mirage/translations";
import type { ActionsMenuProps } from "../ActionsMenu";
import { ManageStackMenu } from "../FullScreenStack/ManageStackMenu";
import { useShareModal } from "../ShareModal/ShareModal";
import { ShareStackButton } from "../StackDetailPage/ShareStackButton";
import { CopyLinkStackButton } from "./CopyLinkStackButton";
import { EditStackButton } from "./EditStackButton";
import styles from "./EmbeddedActions.module.css";

export type EmbeddedActionsProps = Omit<
  ActionsMenuProps,
  "onShare" | "stack" | "showPinnedIcon" | "iconColor" | "isNewStack"
> & {
  stack: stacks.Stack | null;
  onClickEdit: () => void;
  currentAccount: users.FullAccount;
};

export function EmbeddedActions({
  stack,
  onClickEdit,
  currentAccount,
  setMenuOpenForStackId,
  menuPlacement,
}: EmbeddedActionsProps) {
  const { openShareModal, shareModalJsx } = useShareModal({ stack });

  return (
    <>
      <div className={styles.container}>
        <div className={styles.buttonContainer}>
          <ShareStackButton
            stack={stack}
            variant="outline"
            iconType="none"
            onClick={openShareModal}
          >
            {i18n.t("share")}
          </ShareStackButton>
          <EditStackButton
            stack={stack}
            onClick={onClickEdit}
            variant="outline"
          >
            {i18n.t("edit")}
          </EditStackButton>
          <CopyLinkStackButton stack={stack} />
          <ManageStackMenu
            stack={stack}
            iconType="more"
            currentAccount={currentAccount}
            setMenuOpenForStackId={setMenuOpenForStackId}
            menuPlacement={menuPlacement}
          />
        </div>
      </div>
      {shareModalJsx}
    </>
  );
}
